import { useState } from 'react'
import { useEventListener } from '..'
import { isMobileWidth } from '../../utils/mobileHelpers'

let resizeTimeOut: NodeJS.Timeout

export const useMobileState = (): boolean => {
  const [isMobile, setIsMobile] = useState(isMobileWidth())

  const sizeChanged = () => {
    clearTimeout(resizeTimeOut)
    resizeTimeOut = setTimeout(handleSizeChange, 200)
  }

  const handleSizeChange = (): void => {
    const newVal = isMobileWidth()
    if (newVal !== isMobile) {
      setIsMobile(newVal)
    }
  }

  useEventListener(window, 'resize', sizeChanged)

  return isMobile
}
